import { render } from "./PreviewHandler.vue?vue&type=template&id=b5129cbe&scoped=true&ts=true"
import script from "./PreviewHandler.ts?vue&type=script&lang=ts"
export * from "./PreviewHandler.ts?vue&type=script&lang=ts"

import "./PreviewHandler.css?vue&type=style&index=0&id=b5129cbe&scoped=true&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5129cbe"]])

export default __exports__